module.exports = __webpack_public_path__ + "img/charts.b7c67944.gif";